<template>
  <div class="results-group">
    <v-tabs :centered="true" :vertical="clientWidth > 335 ? false : true">
      <v-tab @click="isToggleResults = !isToggleResults">Adequação Calórica</v-tab>
      <v-tab @click="isToggleResults = !isToggleResults">Adequação Protéica</v-tab>
    </v-tabs>
    <div class="chart-app">
      <app-chart :dataFrom="calData" v-if="toggleResults" />
      <app-chart :dataFrom="proteinData" v-if="!toggleResults" />
    </div>
    <div class="more-details caption">
      <p>
        {{toggleResults
        ? `Quantidade de kcal recebida: ${calData.calAmount}`
        : `Quantidade de g(PTN) recebida: ${proteinData.proteinAmount}`}}
      </p>
      <p>
        {{toggleResults
        ? `Quantidade de kcal/kg: ${calData.relative}`
        : `Quantidade de g/kg: ${proteinData.relative}`}}
      </p>
      <i
        @click="dialog = true"
        style="font-size: 16px; margin-top: 10px"
        class="fas fa-info-circle"
      ></i>
      <v-dialog v-model="dialog" max-width="250px">
        <div class="info-diet">
          <p>Dieta para base de cálculo :)</p>
          <p style="font-weight: bold;">{{toCalculate.diet.title}}</p>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saveData: null,
      dialog: false,
      clientWidth: window.innerWidth,
      isToggleResults: true,
      calData: {
        label: "% Calórica",
        text: "Adequação Calórica"
      },
      proteinData: {
        label: "% Protéica",
        text: "Adequação Protéica"
      }
    };
  },
  computed: {
    toggleResults() {
      return this.isToggleResults;
    }
  },
  props: {
    toCalculate: {}
  },
  methods: {
    calculate() {
      let calRef = this.saveData.diet.cal;
      let proteinRef = this.saveData.diet.protein;

      let patient = this.saveData.patient;

      let calAmount = calRef * patient.volume; //kcal
      let proteinAmount = proteinRef * patient.volume; //gPTN

      this.calData.calAmount = calAmount.toFixed(2);
      this.calData.relative = (calAmount / patient.body).toFixed(2);
      this.proteinData.proteinAmount = proteinAmount.toFixed(2);
      this.proteinData.relative = (proteinAmount / patient.body).toFixed(2);

      let calGot = calAmount / (patient.body * patient.cal);
      let proteinGot = proteinAmount / (patient.body * patient.protein);
      this.calCalc(calGot.toFixed(2));
      this.proteinCalc(proteinGot.toFixed(2));

      if (this.saveData.saveData) {
        this.recordCalc();
      }
    },
    calCalc(calGot) {
      this.calData.got = calGot;
      this.calData.didNotGet = (1 - calGot).toFixed(2);
      this.calData.didNotGet > 0
        ? (this.calData.isCool = "Defasagem Calórica")
        : (this.calData.isCool = "Excesso Calórico");
    },
    proteinCalc(proteinGot) {
      this.proteinData.got = proteinGot;
      this.proteinData.didNotGet = (1 - proteinGot).toFixed(2);
      this.proteinData.didNotGet > 0
        ? (this.proteinData.isCool = "Defasagem Protéica")
        : (this.proteinData.isCool = "Excesso Protéica");
    },
    recordCalc() {
      let date = new Date();
      this.saveData.date = date;
      this.saveData.calData = this.calData;
      this.saveData.proteinData = this.proteinData;
      this.$store.dispatch("history/recordCalc", this.saveData);
    }
  },
  created() {
    this.saveData = this.toCalculate;
    this.calculate();
  },
  components: {
    AppChart: () => import("./Chart")
  }
};
</script>

<style scoped>
.results-group {
  background: #fff;
  padding: 10px;
}
.chart-app {
  margin-top: 20px;
}

.v-item-group,
.v-slide-group__content {
  width: 100% !important;
}

.more-details p {
  margin-bottom: 0px;
}

.info-diet {
  background: #fff;
  padding: 15px;
}

.info-diet p {
  margin-bottom: 5px;
}
</style>